import { PlateElement } from 'platejs/react';

export function LinkElement(props: any) {
    const url = props?.element?.url || '#';
    return (
        <PlateElement
            as="a"
            {...props}
            attributes={{
                ...props.attributes,
                href: url,
                target: '_blank',
                rel: 'noreferrer noopener',
                style: { color: '#2383e2', textDecoration: 'underline' },
            }}
        />
    );
}
